export const USER_ROLES = {
  DIRECTOR_USER: "Director",
  SUPER_USER: "Super",
  MD_USER: "MD",
  EXECUTIVE_USER: "Executive",
  ADMIN_USER: "Admin",
  MANAGER_USER: "Manager",
  SUPERVISOR_USER: "Supervisor",
  EMPLOYEE_USER: "Employee",
  GUEST_USER: "Guest",
};

export const userRolesAccessRights = (role: string) => {};
